export const environment = {
  production: false,
   // live api
  apiUrl: 'https://itrade.multiboxxshop.com/api/'
//  apiUrl: 'http://166.63.125.155/iTradePortal_V1/iTradePortalApi/api/',
  // apiUrl: 'http://localhost:5000/api/',
// apiUrl: 'http://96.125.172.239/iTradePortal_V3/iTradePortalApi/api/',

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts